export default "__VITE_ASSET__Fe6MEG1f__"